/******************************************************************************
 * This file was generated by langium-cli 4.2.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

/* eslint-disable */
import * as langium from 'langium';

/** Contains the reachable terminals & keywords and all available types of the 'ArchitectureGrammar' language. */
export namespace ArchitectureGrammar {

    export const Terminals = {
        ARROW_DIRECTION: /L|R|T|B/,
        ARROW_GROUP: /\{group\}/,
        ARROW_INTO: /<|>/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        ID: /[\w]([-\w]*\w)?/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
        ARCH_ICON: /\([\w-:]+\)/,
        ARCH_TITLE: /\[(?:"([^"\\]|\\.)*"|'([^'\\]|\\.)*'|[\w ]+)\]/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "-"
        | "--"
        | ":"
        | "architecture-beta"
        | "group"
        | "in"
        | "junction"
        | "service";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Architecture: Architecture
        Edge: Edge
        Group: Group
        Junction: Junction
        Service: Service
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'GitGraphGrammar' language. */
export namespace GitGraphGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        INT: /0|[1-9][0-9]*(?!\.)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
        REFERENCE: /\w([-\./\w]*[-\w])?/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | ":"
        | "BT"
        | "HIGHLIGHT"
        | "LR"
        | "NORMAL"
        | "REVERSE"
        | "TB"
        | "branch"
        | "checkout"
        | "cherry-pick"
        | "commit"
        | "gitGraph"
        | "gitGraph:"
        | "id:"
        | "merge"
        | "msg:"
        | "order:"
        | "parent:"
        | "switch"
        | "tag:"
        | "type:";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Branch: Branch
        Checkout: Checkout
        CherryPicking: CherryPicking
        Commit: Commit
        Direction: Direction
        GitGraph: GitGraph
        Merge: Merge
        Statement: Statement
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'InfoGrammar' language. */
export namespace InfoGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "info"
        | "showInfo";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Info: Info
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'PacketGrammar' language. */
export namespace PacketGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        INT: /0|[1-9][0-9]*(?!\.)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "+"
        | "-"
        | ":"
        | "packet"
        | "packet-beta";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Packet: Packet
        PacketBlock: PacketBlock
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'PieGrammar' language. */
export namespace PieGrammar {

    export const Terminals = {
        NUMBER_PIE: /(?:-?[0-9]+\.[0-9]+(?!\.))|(?:-?(0|[1-9][0-9]*)(?!\.))/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | ":"
        | "pie"
        | "showData";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Pie: Pie
        PieSection: PieSection
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'RadarGrammar' language. */
export namespace RadarGrammar {

    export const Terminals = {
        GRATICULE: /circle|polygon/,
        BOOLEAN: /true|false/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        NUMBER: /(?:[0-9]+\.[0-9]+(?!\.))|(?:0|[1-9][0-9]*(?!\.))/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        ID: /[\w]([-\w]*\w)?/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | ","
        | ":"
        | "["
        | "]"
        | "axis"
        | "curve"
        | "graticule"
        | "max"
        | "min"
        | "radar-beta"
        | "radar-beta:"
        | "showLegend"
        | "ticks"
        | "{"
        | "}";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Axis: Axis
        Curve: Curve
        Entry: Entry
        Option: Option
        Radar: Radar
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'TreemapGrammar' language. */
export namespace TreemapGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        TREEMAP_KEYWORD: /treemap-beta|treemap/,
        CLASS_DEF: /classDef\s+([a-zA-Z_][a-zA-Z0-9_]+)(?:\s+([^;\r\n]*))?(?:;)?/,
        STYLE_SEPARATOR: /:::/,
        SEPARATOR: /:/,
        COMMA: /,/,
        INDENTATION: /[ \t]{1,}/,
        WS: /[ \t]+/,
        ML_COMMENT: /\%\%[^\n]*/,
        NL: /\r?\n/,
        ID2: /[a-zA-Z_][a-zA-Z0-9_]*/,
        NUMBER2: /[0-9_\.\,]+/,
        STRING2: /"[^"]*"|'[^']*'/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames = never;

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        ClassDefStatement: ClassDefStatement
        Item: Item
        Leaf: Leaf
        Section: Section
        Treemap: Treemap
        TreemapRow: TreemapRow
    }

}


// the terminals, keywords and types of the whole 'Mermaid' project

export const MermaidTerminals = {
    ...ArchitectureGrammar.Terminals,
    ...GitGraphGrammar.Terminals,
    ...InfoGrammar.Terminals,
    ...PacketGrammar.Terminals,
    ...PieGrammar.Terminals,
    ...RadarGrammar.Terminals,
    ...TreemapGrammar.Terminals,
};

export type MermaidTerminalNames = keyof typeof MermaidTerminals;

export type MermaidKeywordNames = ArchitectureGrammar.KeywordNames | GitGraphGrammar.KeywordNames | InfoGrammar.KeywordNames | PacketGrammar.KeywordNames | PieGrammar.KeywordNames | RadarGrammar.KeywordNames | TreemapGrammar.KeywordNames;

export type MermaidTokenNames = MermaidTerminalNames | MermaidKeywordNames;

export type MermaidAstType = ArchitectureGrammar.AstType & GitGraphGrammar.AstType & InfoGrammar.AstType & PacketGrammar.AstType & PieGrammar.AstType & RadarGrammar.AstType & TreemapGrammar.AstType


// all type definitions of the the whole 'Mermaid' project

export interface Architecture extends langium.AstNode {
    readonly $type: 'Architecture';
    accDescr?: string;
    accTitle?: string;
    edges: Array<Edge>;
    groups: Array<Group>;
    junctions: Array<Junction>;
    services: Array<Service>;
    title?: string;
}

export const Architecture = {
    $type: 'Architecture',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    edges: 'edges',
    groups: 'groups',
    junctions: 'junctions',
    services: 'services',
    title: 'title'
} as const;

export function isArchitecture(item: unknown): item is Architecture {
    return reflection.isInstance(item, Architecture.$type);
}

export interface Axis extends langium.AstNode {
    readonly $container: Radar;
    readonly $type: 'Axis';
    label?: string;
    name: string;
}

export const Axis = {
    $type: 'Axis',
    label: 'label',
    name: 'name'
} as const;

export function isAxis(item: unknown): item is Axis {
    return reflection.isInstance(item, Axis.$type);
}

export interface Branch extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Branch' | 'EOL';
    name: string;
    order: number;
}

export const Branch = {
    $type: 'Branch',
    name: 'name',
    order: 'order'
} as const;

export function isBranch(item: unknown): item is Branch {
    return reflection.isInstance(item, Branch.$type);
}

export interface Checkout extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Checkout' | 'EOL';
    branch: string;
}

export const Checkout = {
    $type: 'Checkout',
    branch: 'branch'
} as const;

export function isCheckout(item: unknown): item is Checkout {
    return reflection.isInstance(item, Checkout.$type);
}

export interface CherryPicking extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'CherryPicking' | 'EOL';
    id: string;
    parent: string;
    tags: Array<string>;
}

export const CherryPicking = {
    $type: 'CherryPicking',
    id: 'id',
    parent: 'parent',
    tags: 'tags'
} as const;

export function isCherryPicking(item: unknown): item is CherryPicking {
    return reflection.isInstance(item, CherryPicking.$type);
}

export type ClassDef = string;

export function isClassDef(item: unknown): item is ClassDef {
    return (typeof item === 'string' && (/classDef\s+([a-zA-Z_][a-zA-Z0-9_]+)(?:\s+([^;\r\n]*))?(?:;)?/.test(item)));
}

export interface ClassDefStatement extends langium.AstNode {
    readonly $type: 'ClassDefStatement';
    className: string;
    styleText: string;
}

export const ClassDefStatement = {
    $type: 'ClassDefStatement',
    className: 'className',
    styleText: 'styleText'
} as const;

export function isClassDefStatement(item: unknown): item is ClassDefStatement {
    return reflection.isInstance(item, ClassDefStatement.$type);
}

export interface Commit extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Commit' | 'EOL';
    id: string;
    message: string;
    tags: Array<string>;
    type: 'HIGHLIGHT' | 'NORMAL' | 'REVERSE';
}

export const Commit = {
    $type: 'Commit',
    id: 'id',
    message: 'message',
    tags: 'tags',
    type: 'type'
} as const;

export function isCommit(item: unknown): item is Commit {
    return reflection.isInstance(item, Commit.$type);
}

export interface Curve extends langium.AstNode {
    readonly $container: Radar;
    readonly $type: 'Curve';
    entries: Array<Entry>;
    label?: string;
    name: string;
}

export const Curve = {
    $type: 'Curve',
    entries: 'entries',
    label: 'label',
    name: 'name'
} as const;

export function isCurve(item: unknown): item is Curve {
    return reflection.isInstance(item, Curve.$type);
}

export interface Direction extends GitGraph {
    readonly $type: 'Direction';
    dir: 'BT' | 'LR' | 'TB';
}

export const Direction = {
    $type: 'Direction',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    dir: 'dir',
    statements: 'statements',
    title: 'title'
} as const;

export function isDirection(item: unknown): item is Direction {
    return reflection.isInstance(item, Direction.$type);
}

export interface Edge extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Edge';
    lhsDir: string;
    lhsGroup: boolean;
    lhsId: string;
    lhsInto: boolean;
    rhsDir: string;
    rhsGroup: boolean;
    rhsId: string;
    rhsInto: boolean;
    title?: string;
}

export const Edge = {
    $type: 'Edge',
    lhsDir: 'lhsDir',
    lhsGroup: 'lhsGroup',
    lhsId: 'lhsId',
    lhsInto: 'lhsInto',
    rhsDir: 'rhsDir',
    rhsGroup: 'rhsGroup',
    rhsId: 'rhsId',
    rhsInto: 'rhsInto',
    title: 'title'
} as const;

export function isEdge(item: unknown): item is Edge {
    return reflection.isInstance(item, Edge.$type);
}

export interface Entry extends langium.AstNode {
    readonly $container: Curve;
    readonly $type: 'Entry';
    axis?: langium.Reference<Axis>;
    value: number;
}

export const Entry = {
    $type: 'Entry',
    axis: 'axis',
    value: 'value'
} as const;

export function isEntry(item: unknown): item is Entry {
    return reflection.isInstance(item, Entry.$type);
}

export type EOL = string;

export function isEOL(item: unknown): item is EOL {
    return typeof item === 'string';
}

export interface GitGraph extends langium.AstNode {
    readonly $type: 'Direction' | 'GitGraph';
    accDescr: string;
    accTitle: string;
    statements: Array<Statement>;
    title: string;
}

export const GitGraph = {
    $type: 'GitGraph',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    statements: 'statements',
    title: 'title'
} as const;

export function isGitGraph(item: unknown): item is GitGraph {
    return reflection.isInstance(item, GitGraph.$type);
}

export interface Group extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Group';
    icon?: string;
    id: string;
    in: string;
    title?: string;
}

export const Group = {
    $type: 'Group',
    icon: 'icon',
    id: 'id',
    in: 'in',
    title: 'title'
} as const;

export function isGroup(item: unknown): item is Group {
    return reflection.isInstance(item, Group.$type);
}

export interface Info extends langium.AstNode {
    readonly $type: 'Info';
    accDescr?: string;
    accTitle?: string;
    title?: string;
}

export const Info = {
    $type: 'Info',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    title: 'title'
} as const;

export function isInfo(item: unknown): item is Info {
    return reflection.isInstance(item, Info.$type);
}

export interface Item extends langium.AstNode {
    readonly $type: 'Item' | 'Leaf' | 'Section';
    classSelector?: string;
    name: string;
}

export const Item = {
    $type: 'Item',
    classSelector: 'classSelector',
    name: 'name'
} as const;

export function isItem(item: unknown): item is Item {
    return reflection.isInstance(item, Item.$type);
}

export interface Junction extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Junction';
    id: string;
    in: string;
}

export const Junction = {
    $type: 'Junction',
    id: 'id',
    in: 'in'
} as const;

export function isJunction(item: unknown): item is Junction {
    return reflection.isInstance(item, Junction.$type);
}

export interface Leaf extends Item {
    readonly $type: 'Leaf';
    value: number;
}

export const Leaf = {
    $type: 'Leaf',
    classSelector: 'classSelector',
    name: 'name',
    value: 'value'
} as const;

export function isLeaf(item: unknown): item is Leaf {
    return reflection.isInstance(item, Leaf.$type);
}

export interface Merge extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'EOL' | 'Merge';
    branch: string;
    id: string;
    tags: Array<string>;
    type: 'HIGHLIGHT' | 'NORMAL' | 'REVERSE';
}

export const Merge = {
    $type: 'Merge',
    branch: 'branch',
    id: 'id',
    tags: 'tags',
    type: 'type'
} as const;

export function isMerge(item: unknown): item is Merge {
    return reflection.isInstance(item, Merge.$type);
}

export type MyNumber = number;

export function isMyNumber(item: unknown): item is MyNumber {
    return typeof item === 'number';
}

export interface Option extends langium.AstNode {
    readonly $container: Radar;
    readonly $type: 'Option';
    name: 'graticule' | 'max' | 'min' | 'showLegend' | 'ticks';
    value: boolean | number | string;
}

export const Option = {
    $type: 'Option',
    name: 'name',
    value: 'value'
} as const;

export function isOption(item: unknown): item is Option {
    return reflection.isInstance(item, Option.$type);
}

export interface Packet extends langium.AstNode {
    readonly $type: 'Packet';
    accDescr?: string;
    accTitle?: string;
    blocks: Array<PacketBlock>;
    title?: string;
}

export const Packet = {
    $type: 'Packet',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    blocks: 'blocks',
    title: 'title'
} as const;

export function isPacket(item: unknown): item is Packet {
    return reflection.isInstance(item, Packet.$type);
}

export interface PacketBlock extends langium.AstNode {
    readonly $container: Packet;
    readonly $type: 'EOL' | 'PacketBlock';
    bits: number;
    end?: number;
    label: string;
    start: number;
}

export const PacketBlock = {
    $type: 'PacketBlock',
    bits: 'bits',
    end: 'end',
    label: 'label',
    start: 'start'
} as const;

export function isPacketBlock(item: unknown): item is PacketBlock {
    return reflection.isInstance(item, PacketBlock.$type);
}

export interface Pie extends langium.AstNode {
    readonly $type: 'Pie';
    accDescr?: string;
    accTitle?: string;
    sections: Array<PieSection>;
    showData: boolean;
    title?: string;
}

export const Pie = {
    $type: 'Pie',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    sections: 'sections',
    showData: 'showData',
    title: 'title'
} as const;

export function isPie(item: unknown): item is Pie {
    return reflection.isInstance(item, Pie.$type);
}

export interface PieSection extends langium.AstNode {
    readonly $container: Pie;
    readonly $type: 'EOL' | 'PieSection';
    label: string;
    value: number;
}

export const PieSection = {
    $type: 'PieSection',
    label: 'label',
    value: 'value'
} as const;

export function isPieSection(item: unknown): item is PieSection {
    return reflection.isInstance(item, PieSection.$type);
}

export interface Radar extends langium.AstNode {
    readonly $type: 'Radar';
    accDescr?: string;
    accTitle?: string;
    axes: Array<Axis>;
    curves: Array<Curve>;
    options: Array<Option>;
    title?: string;
}

export const Radar = {
    $type: 'Radar',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    axes: 'axes',
    curves: 'curves',
    options: 'options',
    title: 'title'
} as const;

export function isRadar(item: unknown): item is Radar {
    return reflection.isInstance(item, Radar.$type);
}

export interface Section extends Item {
    readonly $type: 'Section';
}

export const Section = {
    $type: 'Section',
    classSelector: 'classSelector',
    name: 'name'
} as const;

export function isSection(item: unknown): item is Section {
    return reflection.isInstance(item, Section.$type);
}

export interface Service extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Service';
    icon?: string;
    iconText?: string;
    id: string;
    in: string;
    title?: string;
}

export const Service = {
    $type: 'Service',
    icon: 'icon',
    iconText: 'iconText',
    id: 'id',
    in: 'in',
    title: 'title'
} as const;

export function isService(item: unknown): item is Service {
    return reflection.isInstance(item, Service.$type);
}

export type Statement = Branch | Checkout | CherryPicking | Commit | Merge;

export const Statement = {
    $type: 'Statement'
} as const;

export function isStatement(item: unknown): item is Statement {
    return reflection.isInstance(item, Statement.$type);
}

export interface Treemap extends langium.AstNode {
    readonly $type: 'Treemap';
    accDescr?: string;
    accTitle?: string;
    title?: string;
    TreemapRows: Array<TreemapRow>;
}

export const Treemap = {
    $type: 'Treemap',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    title: 'title',
    TreemapRows: 'TreemapRows'
} as const;

export function isTreemap(item: unknown): item is Treemap {
    return reflection.isInstance(item, Treemap.$type);
}

export interface TreemapRow extends langium.AstNode {
    readonly $container: Treemap;
    readonly $type: 'ClassDef' | 'TreemapRow';
    indent?: string;
    item: Item;
}

export const TreemapRow = {
    $type: 'TreemapRow',
    indent: 'indent',
    item: 'item'
} as const;

export function isTreemapRow(item: unknown): item is TreemapRow {
    return reflection.isInstance(item, TreemapRow.$type);
}

export class MermaidAstReflection extends langium.AbstractAstReflection {
    override readonly types = {
        Architecture: {
            name: Architecture.$type,
            properties: {
                accDescr: {
                    name: Architecture.accDescr
                },
                accTitle: {
                    name: Architecture.accTitle
                },
                edges: {
                    name: Architecture.edges,
                    defaultValue: []
                },
                groups: {
                    name: Architecture.groups,
                    defaultValue: []
                },
                junctions: {
                    name: Architecture.junctions,
                    defaultValue: []
                },
                services: {
                    name: Architecture.services,
                    defaultValue: []
                },
                title: {
                    name: Architecture.title
                }
            },
            superTypes: []
        },
        Axis: {
            name: Axis.$type,
            properties: {
                label: {
                    name: Axis.label
                },
                name: {
                    name: Axis.name
                }
            },
            superTypes: []
        },
        Branch: {
            name: Branch.$type,
            properties: {
                name: {
                    name: Branch.name
                },
                order: {
                    name: Branch.order
                }
            },
            superTypes: [Statement.$type]
        },
        Checkout: {
            name: Checkout.$type,
            properties: {
                branch: {
                    name: Checkout.branch
                }
            },
            superTypes: [Statement.$type]
        },
        CherryPicking: {
            name: CherryPicking.$type,
            properties: {
                id: {
                    name: CherryPicking.id
                },
                parent: {
                    name: CherryPicking.parent
                },
                tags: {
                    name: CherryPicking.tags,
                    defaultValue: []
                }
            },
            superTypes: [Statement.$type]
        },
        ClassDefStatement: {
            name: ClassDefStatement.$type,
            properties: {
                className: {
                    name: ClassDefStatement.className
                },
                styleText: {
                    name: ClassDefStatement.styleText
                }
            },
            superTypes: []
        },
        Commit: {
            name: Commit.$type,
            properties: {
                id: {
                    name: Commit.id
                },
                message: {
                    name: Commit.message
                },
                tags: {
                    name: Commit.tags,
                    defaultValue: []
                },
                type: {
                    name: Commit.type
                }
            },
            superTypes: [Statement.$type]
        },
        Curve: {
            name: Curve.$type,
            properties: {
                entries: {
                    name: Curve.entries,
                    defaultValue: []
                },
                label: {
                    name: Curve.label
                },
                name: {
                    name: Curve.name
                }
            },
            superTypes: []
        },
        Direction: {
            name: Direction.$type,
            properties: {
                accDescr: {
                    name: Direction.accDescr
                },
                accTitle: {
                    name: Direction.accTitle
                },
                dir: {
                    name: Direction.dir
                },
                statements: {
                    name: Direction.statements,
                    defaultValue: []
                },
                title: {
                    name: Direction.title
                }
            },
            superTypes: [GitGraph.$type]
        },
        Edge: {
            name: Edge.$type,
            properties: {
                lhsDir: {
                    name: Edge.lhsDir
                },
                lhsGroup: {
                    name: Edge.lhsGroup,
                    defaultValue: false
                },
                lhsId: {
                    name: Edge.lhsId
                },
                lhsInto: {
                    name: Edge.lhsInto,
                    defaultValue: false
                },
                rhsDir: {
                    name: Edge.rhsDir
                },
                rhsGroup: {
                    name: Edge.rhsGroup,
                    defaultValue: false
                },
                rhsId: {
                    name: Edge.rhsId
                },
                rhsInto: {
                    name: Edge.rhsInto,
                    defaultValue: false
                },
                title: {
                    name: Edge.title
                }
            },
            superTypes: []
        },
        Entry: {
            name: Entry.$type,
            properties: {
                axis: {
                    name: Entry.axis,
                    referenceType: Axis.$type
                },
                value: {
                    name: Entry.value
                }
            },
            superTypes: []
        },
        GitGraph: {
            name: GitGraph.$type,
            properties: {
                accDescr: {
                    name: GitGraph.accDescr
                },
                accTitle: {
                    name: GitGraph.accTitle
                },
                statements: {
                    name: GitGraph.statements,
                    defaultValue: []
                },
                title: {
                    name: GitGraph.title
                }
            },
            superTypes: []
        },
        Group: {
            name: Group.$type,
            properties: {
                icon: {
                    name: Group.icon
                },
                id: {
                    name: Group.id
                },
                in: {
                    name: Group.in
                },
                title: {
                    name: Group.title
                }
            },
            superTypes: []
        },
        Info: {
            name: Info.$type,
            properties: {
                accDescr: {
                    name: Info.accDescr
                },
                accTitle: {
                    name: Info.accTitle
                },
                title: {
                    name: Info.title
                }
            },
            superTypes: []
        },
        Item: {
            name: Item.$type,
            properties: {
                classSelector: {
                    name: Item.classSelector
                },
                name: {
                    name: Item.name
                }
            },
            superTypes: []
        },
        Junction: {
            name: Junction.$type,
            properties: {
                id: {
                    name: Junction.id
                },
                in: {
                    name: Junction.in
                }
            },
            superTypes: []
        },
        Leaf: {
            name: Leaf.$type,
            properties: {
                classSelector: {
                    name: Leaf.classSelector
                },
                name: {
                    name: Leaf.name
                },
                value: {
                    name: Leaf.value
                }
            },
            superTypes: [Item.$type]
        },
        Merge: {
            name: Merge.$type,
            properties: {
                branch: {
                    name: Merge.branch
                },
                id: {
                    name: Merge.id
                },
                tags: {
                    name: Merge.tags,
                    defaultValue: []
                },
                type: {
                    name: Merge.type
                }
            },
            superTypes: [Statement.$type]
        },
        Option: {
            name: Option.$type,
            properties: {
                name: {
                    name: Option.name
                },
                value: {
                    name: Option.value,
                    defaultValue: false
                }
            },
            superTypes: []
        },
        Packet: {
            name: Packet.$type,
            properties: {
                accDescr: {
                    name: Packet.accDescr
                },
                accTitle: {
                    name: Packet.accTitle
                },
                blocks: {
                    name: Packet.blocks,
                    defaultValue: []
                },
                title: {
                    name: Packet.title
                }
            },
            superTypes: []
        },
        PacketBlock: {
            name: PacketBlock.$type,
            properties: {
                bits: {
                    name: PacketBlock.bits
                },
                end: {
                    name: PacketBlock.end
                },
                label: {
                    name: PacketBlock.label
                },
                start: {
                    name: PacketBlock.start
                }
            },
            superTypes: []
        },
        Pie: {
            name: Pie.$type,
            properties: {
                accDescr: {
                    name: Pie.accDescr
                },
                accTitle: {
                    name: Pie.accTitle
                },
                sections: {
                    name: Pie.sections,
                    defaultValue: []
                },
                showData: {
                    name: Pie.showData,
                    defaultValue: false
                },
                title: {
                    name: Pie.title
                }
            },
            superTypes: []
        },
        PieSection: {
            name: PieSection.$type,
            properties: {
                label: {
                    name: PieSection.label
                },
                value: {
                    name: PieSection.value
                }
            },
            superTypes: []
        },
        Radar: {
            name: Radar.$type,
            properties: {
                accDescr: {
                    name: Radar.accDescr
                },
                accTitle: {
                    name: Radar.accTitle
                },
                axes: {
                    name: Radar.axes,
                    defaultValue: []
                },
                curves: {
                    name: Radar.curves,
                    defaultValue: []
                },
                options: {
                    name: Radar.options,
                    defaultValue: []
                },
                title: {
                    name: Radar.title
                }
            },
            superTypes: []
        },
        Section: {
            name: Section.$type,
            properties: {
                classSelector: {
                    name: Section.classSelector
                },
                name: {
                    name: Section.name
                }
            },
            superTypes: [Item.$type]
        },
        Service: {
            name: Service.$type,
            properties: {
                icon: {
                    name: Service.icon
                },
                iconText: {
                    name: Service.iconText
                },
                id: {
                    name: Service.id
                },
                in: {
                    name: Service.in
                },
                title: {
                    name: Service.title
                }
            },
            superTypes: []
        },
        Statement: {
            name: Statement.$type,
            properties: {
            },
            superTypes: []
        },
        Treemap: {
            name: Treemap.$type,
            properties: {
                accDescr: {
                    name: Treemap.accDescr
                },
                accTitle: {
                    name: Treemap.accTitle
                },
                title: {
                    name: Treemap.title
                },
                TreemapRows: {
                    name: Treemap.TreemapRows,
                    defaultValue: []
                }
            },
            superTypes: []
        },
        TreemapRow: {
            name: TreemapRow.$type,
            properties: {
                indent: {
                    name: TreemapRow.indent
                },
                item: {
                    name: TreemapRow.item
                }
            },
            superTypes: []
        }
    } as const satisfies langium.AstMetaData
}

export const reflection = new MermaidAstReflection();
